import { COOKIE_NAMES } from '../utils/cookies/cookies.consts'
import { getCookie, setCookie, removeCookie } from 'typescript-cookie'
import { logger } from './logger'
import StorageManager from './StorageManager'
import { tryParseCookieData } from './UserSettingsProvider'
import { isEmptyObject } from 'utils/utils'

const LEGACY_STORAGE_KEY = 'userEmail'
const COOKIE_OPTIONS = { expires: 365 * 4, path: '/' } // 4 years

/**
 * One-time migration from localStorage to cookie
 * Runs automatically on first getUserEmail() call after upgrade
 */
const migrateFromLocalStorage = () => {
  try {
    const legacyEmail = StorageManager.get(LEGACY_STORAGE_KEY)
    if (!legacyEmail) {
      return undefined
    }
    setUserEmail(legacyEmail)
    StorageManager.remove(LEGACY_STORAGE_KEY)
    logger.info('Migrated user email from localStorage to cookie')
    return legacyEmail
  } catch (error) {
    logger.error('Failed to migrate email from localStorage to cookie', {
      error: error.message,
    })
  }
  return undefined
}

/**
 * @returns {string}
 */
export const getUserEmail = () => {
  let email = tryParseCookieData(getCookie(COOKIE_NAMES.USER_EMAIL))

  // If no cookie exists, check for legacy localStorage value and migrate
  if (!email || isEmptyObject(email)) {
    email = migrateFromLocalStorage()
  }

  return email
}

export const setUserEmail = (email) => {
  setCookie(
    COOKIE_NAMES.USER_EMAIL,
    btoa(JSON.stringify(email)),
    COOKIE_OPTIONS
  )
}

export const clearUserEmail = () => {
  removeCookie(COOKIE_NAMES.USER_EMAIL, { path: '/' })
}
